import axios from "axios";
import {
    patientConnectUrl,
    patientConnectHeaders,
} from "@/config";
//import useVuelidate from '@vuelidate/core'

export default {
    components: {

    },
    /*
    setup() {
        return {
            v$: useVuelidate()
        }
    },
    */

    props: {
        eligibility_Form: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            eligibilityForm: this.eligibility_Form
        };
    },

    methods: {
        getUtmSource() {
            let urlVars = getUrlVars()
            var utmSource = urlVars["utm_source"]
            var utmMedium = urlVars["utm_medium"]
            var utmCampaign = urlVars["utm_campaign"]
            var utmId = urlVars["utm_id"]
            var utmContent = urlVars["utm_content"]
                // var sources = 'utm_source= ' + utmSource + ', utm_medium= ' + utmMedium + ', utm_campaign= ' + utmCampaign + ', utm_id= ' + utmId + ', utm_content= ' + utmContent
            var sources = sieveUtmProp('utm_source=', utmSource) + sieveUtmProp('utm_medium=', utmMedium) + sieveUtmProp('utm_campaign=', utmCampaign) + sieveUtmProp('utm_id=', utmId) + sieveUtmProp('utm_content=', utmContent)

            return sources;

            //check if a utm property is undefined or has a value
            function sieveUtmProp(fieldProp, fieldValue) {
                if (fieldValue != undefined) {
                    return ' ' + fieldProp + fieldValue + ',';
                }
                return '';
            }

            function getUrlVars() {
                let vars = {};
                window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m, key, value) {
                    vars[key] = value;
                });
                return vars;
            }
        },
        onSiteSelect($event) {
            this.form.site = $event.target.value;
            this.form.siteId = $event.target.value
        },
        onConsentChange($event) {
            this.form.consent = $event;
        },
        getPatientConnectUrl() {
            const isPatientConnectLocal = process.env.VUE_APP_IS_PATIENT_CONNECT_LOCAL;
            if (isPatientConnectLocal === "false") {
                return patientConnectUrl.absolutePath
            } else {
                return patientConnectUrl.rel
            }
        },
        getQueAndAnswerField: function(eligibilityForm) {
            var queAndAnswer = []

            eligibilityForm.forEach((formFields, index) => {
                queAndAnswer.push({
                    question_id: index + 1,
                    question_text: formFields.field_name,
                    question_answer: formFields.field_data
                });
            })
            return queAndAnswer
        },

        async post(form, eligibilityForm) {

            const isFormInvalid = this.v$.form.$invalid
            
            if (isFormInvalid) {
                console.log("form is invalid")
                return
            }

            console.log("form is valid")

            let formData = {
                "language": this.$i18n.locale,
                'recipientName': form.recipientName,
                'name': form.name,
                'sms': form.sms,
                'email': form.email,
                'site': form.site,
                'source': this.getUtmSource(),
                'questions': this.getQueAndAnswerField(eligibilityForm),
            };


            console.log("this is the form data: ", JSON.stringify(formData));

            axios.post(this.getPatientConnectUrl(), formData, {
                    headers: patientConnectHeaders
                })
                .then((res) => {
                    console.log("this is the response: ", res);
                    this.$emit("formSubmittedEvent");
                })
                .catch((error) => {
                    console.log("error just occured: ", error);
                    this.$emit("formSubmissionErrorEvent");
                })
                .finally(() => {
                    //Perform action in always
                });

        },

    },

}